import { Project } from './project'
import { Topic } from './topic'

export class Note {
  _text: string
  isNew: boolean

  constructor(
    public id: string,
    public parentId: string,
    public project: Project,
    text: string,
    public date: Date,
    public topic: Topic
  ) {
    this.text = text
    this.isNew = this._text == ''
    if (topic)
      project.notesMap.set(`${this.parentId}%%${this.topic.id}`, this)
    else
      project.notesMap.set(this.parentId, this)
  }


  set text(txt) {
    txt = txt || ''
    this._text = txt.trim()
  }

  get text() {
    return this._text
  }

  get saveParams() {
    let dct = {
      id: this.id,
      projectId: this.project.id,
      parentId: this.parentId,
      text: this.text,
      date: this.date.toJSON()
    }
    if (this.topic) {
      dct['isTopicNote'] = true
      dct['topicId'] = this.topic.id
      dct['dbRecordId'] = this.parentId
    } else
      dct['fun'] = 'saveNote'
    return dct
  }

  get deleteParams() {
    return {
      fun: 'deleteNote',
      id: this.id,
      projectId: this.project.id
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/note.ts